import React from 'react';
import { connect } from 'react-redux';
import { getReps } from '../../ducks/workoutActions';


class MethodSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMethod: props.method ? props.method : null
    }
    this.myRef = React.createRef();
  }

  componentDidMount(){
    this.props.getReps();
    this.myRef.current && this.myRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  render() {

    let { reps, setFieldValue } = this.props;
    return (
      <div className="method-section">
        <div className="section-title">
          Method
          <i className="fas fa-chevron-down"></i>
        </div>
        <ul className="method-list">
          {reps && reps.map(rep => {
            return(
              <li
                className={`${this.state.activeMethod === rep.method ? 'active' : ''} li-link`} key={rep.id}
                ref={this.state.activeMethod === rep.method ? this.myRef : null}
                onClick={e => {
                  let newActiveMethod = this.state.activeMethod === rep.method ? null : rep.method;
                  setFieldValue('method', newActiveMethod ? rep.method : '');
                  this.setState({activeMethod: newActiveMethod});
                }}
              >
                {rep.method}
              </li>
              );
          })}
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    reps: state.workoutReducer.reps
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getReps: workoutId => dispatch(getReps())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MethodSection);
